/*
 * Compatibility rules for the JESA paella set builder.
 * Copied verbatim from assets/configurador-jesa.js (the classic set builder, kept as a backup).
 * Edit the rules here: this file is what the new set builder uses.
 */
window.JESA_REGLAS = (function () {
// 1. Matriz de compatibilidades inversas de las Paellas Estándar (Manda el plato)
const reglasJesaInversas = {
  "32 cm - 5 raciones": { paellerosValidos: ["1-aro-20-cm", "1-aro-25-cm", "2-aros-40-cm", "3-aros-60-cm", "3-aros-65-cm"] },
  "34 cm - 6 raciones": { paellerosValidos: ["1-aro-20-cm", "1-aro-25-cm", "2-aros-40-cm", "2-aros-45-cm", "3-aros-60-cm", "3-aros-65-cm"] },
  "36 cm - 7 raciones": { paellerosValidos: ["1-aro-20-cm", "1-aro-25-cm", "1-aro-30-cm", "2-aros-30-cm", "2-aros-40-cm", "2-aros-45-cm", "3-aros-45-cm", "3-aros-60-cm", "3-aros-65-cm"] },
  "38 cm - 8 raciones": { paellerosValidos: ["1-aro-25-cm", "1-aro-30-cm", "2-aros-30-cm", "2-aros-45-cm", "2-aros-50-cm", "3-aros-45-cm", "3-aros-65-cm", "3-aros-70-cm"] },
  "40 cm - 9 raciones": { paellerosValidos: ["1-aro-30-cm", "2-aros-30-cm", "2-aros-35-cm", "2-aros-50-cm", "3-aros-45-cm", "3-aros-55-cm", "3-aros-70-cm"] },
  "42 cm - 10 raciones": { paellerosValidos: ["1-aro-30-cm", "2-aros-30-cm", "2-aros-35-cm", "2-aros-50-cm", "3-aros-45-cm", "3-aros-55-cm", "3-aros-70-cm"] },
  "46 cm - 12 raciones": { paellerosValidos: ["1-aro-30-cm", "2-aros-30-cm", "2-aros-35-cm", "2-aros-40-cm", "2-aros-50-cm", "3-aros-45-cm", "3-aros-55-cm", "3-aros-60-cm", "3-aros-70-cm"] },
  "50 cm - 14 raciones": { paellerosValidos: ["2-aros-35-cm", "2-aros-40-cm", "3-aros-55-cm", "3-aros-60-cm"] },
  "55 cm - 16 raciones": { paellerosValidos: ["2-aros-40-cm", "2-aros-45-cm", "3-aros-45-cm", "3-aros-60-cm", "3-aros-65-cm"] },
  "60 cm - 19 raciones": { paellerosValidos: ["2-aros-45-cm", "2-aros-50-cm", "3-aros-45-cm", "3-aros-65-cm", "3-aros-70-cm"] },
  "65 cm - 22 raciones": { paellerosValidos: ["2-aros-50-cm", "3-aros-45-cm", "3-aros-55-cm", "3-aros-70-cm"] },
  "70 cm - 25 raciones": { paellerosValidos: ["2-aros-50-cm", "3-aros-55-cm", "3-aros-60-cm", "3-aros-70-cm"] },
  "75 cm - 32 raciones": { paellerosValidos: ["3-aros-55-cm", "3-aros-60-cm"] },
  "80 cm - 40 raciones": { paellerosValidos: ["3-aros-60-cm", "3-aros-65-cm", "3-aros-70-cm"] },
  "85 cm - 45 raciones": { paellerosValidos: ["3-aros-65-cm", "3-aros-70-cm"] },
  "90 cm - 50 raciones": { paellerosValidos: ["3-aros-70-cm"] }
};

// 1B. Matriz Oficial de validación según los paelleros planos (L30, L40, L50, L60, L70)
const reglasPlanosPorMedida = {
  "30": ["40", "42", "46", "50", "55"],
  "40": ["34", "36", "38", "40", "55", "60", "65"],
  "50": ["42", "46", "50", "55", "65", "70", "75", "80"],
  "60": ["34", "36", "38", "40", "55", "60", "65", "80", "85", "90"],
  "70": ["42", "46", "50", "55", "70", "80", "100"]
};
// 2. Matriz de compatibilidades secundarias para los Soportes
const reglasSoportes = {
  "1-aro-20-cm": ["patas-paellero"], "1-aro-25-cm": ["patas-paellero"],
  "1-aro-30-cm": ["soporte-regulable", "patas-paellero"], "2-aros-30-cm": ["soporte-regulable", "patas-paellero"],
  "2-aros-35-cm": ["soporte-regulable", "patas-paellero"], "2-aros-40-cm": ["soporte-regulable", "soporte-reforzado"],
  "2-aros-45-cm": ["soporte-regulable", "soporte-reforzado"], "2-aros-50-cm": ["soporte-regulable", "soporte-reforzado"],
  "3-aros-45-cm": ["soporte-regulable", "soporte-reforzado"], "3-aros-55-cm": ["soporte-regulable", "soporte-reforzado"],
  "3-aros-60-cm": ["soporte-regulable", "soporte-reforzado"], "3-aros-65-cm": ["soporte-regulable", "soporte-reforzado"],
  "3-aros-70-cm": ["soporte-regulable", "soporte-reforzado"],
  "plano-30": ["soporte-regulable", "patas-paellero"], "plano-40": ["soporte-regulable", "soporte-reforzado"],
  "plano-50": ["soporte-regulable", "soporte-reforzado"], "plano-60": ["soporte-regulable", "soporte-reforzado"],
  "plano-70": ["soporte-regulable", "soporte-reforzado"]
};

// 3. Matriz de compatibilidades para los Reguladores con Goma
const reglasReguladores = {
  "1-aro-20-cm": ["regulador-30-goma", "regulador-50-goma"], "1-aro-25-cm": ["regulador-30-goma", "regulador-50-goma"],
  "1-aro-30-cm": ["regulador-30-goma", "regulador-50-goma"], "2-aros-30-cm": ["regulador-30-goma", "regulador-50-goma"],
  "2-aros-35-cm": ["regulador-30-goma", "regulador-50-goma"], "2-aros-40-cm": ["regulador-30-goma", "regulador-50-goma"],
  "2-aros-45-cm": ["regulador-30-goma", "regulador-50-goma"], "2-aros-50-cm": ["regulador-30-goma", "regulador-50-goma"],
  "3-aros-45-cm": ["regulador-30-goma", "regulador-50-goma"], "3-aros-55-cm": ["regulador-50-goma"],
  "3-aros-60-cm": ["regulador-50-goma"], "3-aros-65-cm": ["regulador-50-goma"], "3-aros-70-cm": ["regulador-50-goma"],
  "plano-30": ["regulador-30-goma", "regulador-50-goma"], "plano-40": ["regulador-50-goma"],
  "plano-50": ["regulador-50-goma"], "plano-60": ["regulador-50-goma"], "plano-70": ["regulador-50-goma"]
};

// 4. Matriz de compatibilidades para los paravientos de paellero
const reglasParavientosPaellero = {
  "1-aro-20-cm": [], "1-aro-25-cm": [], "1-aro-30-cm": [], "2-aros-30-cm": ["paravientos-2-aros"],
  "2-aros-35-cm": ["paravientos-2-aros"], "2-aros-40-cm": ["paravientos-2-aros"], "2-aros-45-cm": ["paravientos-2-aros"],
  "2-aros-50-cm": ["paravientos-2-aros"], "3-aros-45-cm": ["paravientos-2-aros"], "3-aros-55-cm": ["paravientos-3-aros"],
  "3-aros-60-cm": ["paravientos-3-aros"], "3-aros-65-cm": ["paravientos-3-aros"], "3-aros-70-cm": ["paravientos-3-aros"],
  "plano-30": [], "plano-40": ["paravientos-2-aros"], "plano-50": ["paravientos-2-aros"],
  "plano-60": ["paravientos-3-aros"], "plano-70": ["paravientos-3-aros"]
};
// 5. Matriz de compatibilidades para Asadores y Planchas
const reglasAsadores = {
  "asador-65": ["2-aros-50-cm", "3-aros-45-cm", "3-aros-55-cm", "3-aros-70-cm"],
  "asador-42": ["1-aro-30-cm", "2-aros-30-cm", "2-aros-35-cm", "2-aros-50-cm", "3-aros-45-cm", "3-aros-55-cm", "3-aros-70-cm"],
  "asador-52": ["2-aros-35-cm", "2-aros-40-cm", "3-aros-55-cm", "3-aros-60-cm"],
  "plancha-46": ["1-aro-30-cm", "2-aros-30-cm", "2-aros-35-cm", "2-aros-40-cm", "2-aros-50-cm", "3-aros-45-cm", "3-aros-55-cm", "3-aros-60-cm", "3-aros-70-cm"]
};
const reglasAsadoresPlanos = {
  "asador-65": ["40", "50", "60"], "asador-42": ["30", "50", "70"],
  "asador-52": ["30", "50", "70"], "plancha-46": ["30", "50", "70"]
};

// 6. Matriz de compatibilidad explícita, independiente y personalizable para SARTENES HONDAS (Todos los tamaños)
const reglasSartenHonda = {
"20": ["1-aro-20-cm"],
  "24": ["1-aro-20-cm"],
  "28": ["1-aro-20-cm", "1-aro-25-cm"],
  "30": ["1-aro-20-cm", "1-aro-25-cm"],
  "32": ["1-aro-20-cm", "1-aro-25-cm", "1-aro-30-cm"],
  "34": ["1-aro-20-cm", "1-aro-25-cm", "1-aro-30-cm", "2-aros-30-cm"],
  "36": ["1-aro-20-cm", "1-aro-25-cm", "1-aro-30-cm", "2-aros-30-cm"],
  "38": ["1-aro-25-cm", "1-aro-30-cm", "2-aros-30-cm", "2-aros-35-cm"],
  "40": ["1-aro-25-cm", "1-aro-30-cm", "2-aros-30-cm", "2-aros-35-cm"],
  "45": ["1-aro-20-cm", "1-aro-25-cm", "2-aros-40-cm", "3-aros-60-cm", "3-aros-65-cm"],
  "50": ["1-aro-20-cm", "1-aro-25-cm", "1-aro-30-cm", "2-aros-30-cm", "2-aros-40-cm", "2-aros-45-cm", "3-aros-45-cm", "3-aros-60-cm", "3-aros-65-cm"],
  "55": ["1-aro-30-cm", "2-aros-30-cm", "2-aros-35-cm", "2-aros-50-cm", "3-aros-45-cm", "3-aros-55-cm", "3-aros-70-cm"],
  "60": ["1-aro-30-cm", "2-aros-30-cm", "2-aros-35-cm", "2-aros-50-cm", "3-aros-45-cm", "3-aros-55-cm", "3-aros-70-cm"],
  "65": ["1-aro-30-cm", "2-aros-30-cm", "2-aros-35-cm", "2-aros-40-cm", "2-aros-50-cm", "3-aros-45-cm", "3-aros-55-cm", "3-aros-60-cm", "3-aros-70-cm"]
};

  return { reglasJesaInversas, reglasPlanosPorMedida, reglasSoportes, reglasReguladores, reglasParavientosPaellero, reglasAsadores, reglasAsadoresPlanos, reglasSartenHonda };
})();
